//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ATRIA",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '0',
        item5: '0',
      },
      text: '',
      item1List: [
        { value: '0', name: 'Hb男性>130g/L,女性>120g/L' },
        { value: '3', name: 'Hb男性<130g/L,女性<120g/L' },
      ],
      item2List: [
        { value: '0', name: 'eGFR>30ml/min/1.73m²' },
        { value: '3', name: 'eGFR<30ml/min/1.73m²' },
      ],
      item3List: [
        { value: '0', name: '年龄<75岁' },
        { value: '2', name: '年龄≥75岁' },
      ]
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
        if (result < 4) {
          self.text = '低危'
        } else if (result == 4) {
          self.text = '中危'
        } else {
          self.text = '高危'
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/ATRIA.vue